import styled from 'styled-components';
import { pallette } from '../../config/pallette';

import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const SectionTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-image: ${({ bgimage }) => `url(${bgimage})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 430px) {
    background-position: 80% 0%;
    padding: 60px 0;
  }
`;

export const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 1200px;
  padding: 120px 0;

  @media (max-width: 1200px) {
    min-width: auto;
    width: calc(100svw - 60px);
    padding: 80px 0;
  }
`;

export const TopSubtitle = styled.h2`
  font-size: 24px;
  color: ${pallette.white};

  @media (max-width: 430px) {
    font-size: 16px;
  }
`;

export const Underline = styled.div`
  margin-top: -12px;
  margin-left: 1px;
  border-bottom: 4px solid ${pallette.main};
  width: 40px;
  @media (max-width: 430px) {
    margin-top: -5px;
    margin-left: 1px;
    width: 68px;
  } 
}
`;

export const TopTitle = styled.h1`
  color: ${pallette.white};
  text-align: left;
  font-size: 60px;
  width: 70%;
  margin: 25px 0 0 0;

  @media (max-width: 430px) {
    font-size: 25px;
    padding: 10px 0;
  }
`;

export const TopBody = styled.p`
  color: ${pallette.white};

  @media (max-width: 430px) {
    font-size: 15px;
    text-align: left;
  }
`;

export const SectionBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 1200px;
  padding: 50px 0;

  @media (max-width: 1200px) {
    min-width: auto;
    width: calc(100svw - 60px);
  }
`;

export const SectionTitle = styled.h3`
  font-weight: bold;
  font-size: 20px;
`;

export const SectionBody = styled.p`
  font-size: 20px;
  text-align: left;
`;

export const LearnSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  padding: 15px 0;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 430px) {
    grid-template-columns: 1fr;
    gap: 46px;
  }
`;

export const LearnCard = styled.div`
  display: flex;
  padding: 10px 20px;
  flex-direction: column;
  border: 1px solid ${pallette.text};
  flex: 0 1 calc(30% - 15px);
  min-height: 220px;

  @media (max-width: 430px) {
    padding: 10px 30px;
    min-height: 220px;
  }
`;

export const LearnCardTitle = styled.h3`
  font-weight: bold;
  text-align: left;
  font-size: 32px;
  margin: 10px 0 0 0;
`;

export const LearnCardTitleMobile = styled.h3`
  font-weight: bold;
  text-align: left;
  font-size: 24px;
  margin: 10px 0 0 0;
`;

export const LearnCardBody = styled.p`
  font-size: 16px;
  text-align: left;

  @media (max-width: 430px) {
    font-size: 16px;
  }
`;

export const LaunchButton = styled(Link)`
  padding: 15px;
  border: 1px solid ${pallette.text};
  color: ${(props) => (props.topbutton ? pallette.white : pallette.text)};
  background-color: ${(props) =>
    props.topbutton ? pallette.main : 'transparent'};
  align-self: ${(props) => (props.topbutton ? 'flex-start' : 'flex-end')};
  margin: 15px 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 430px) {
    margin: 30px 0;
  }
`;

export const LaunchButtonText = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;

  @media (max-width: 430px) {
    font-size: 16px;
  }
`;
